// src/store/thunks/sixDetail/deleteFileThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';

import {
  createFileDeletedEvent,
  publishSixEventThunk,
} from '../poc/messaging/publishSixEventThunk';

export const deleteFileThunk = createAppAsyncThunk<
  undefined,
  { sixId: string; fileId: string }
>(
  'sixDetail/deleteFile',
  withLoader(
    async({ sixId, fileId }, { extra, dispatch }) => {
      await extra.sixDetailService.deleteFile(sixId, fileId);
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixId)).unwrap();
      await dispatch(
        publishSixEventThunk(createFileDeletedEvent({ sixId, fileId }))
      ).unwrap();
      return undefined;
    }
  )
);
